import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface SequenceSearchMessageRowProps {
  message: string;
}

function SequenceSearchMessageRow({message}: SequenceSearchMessageRowProps): JSX.Element {
  return (
    <div className="list-group-item">
      <div className="faded">{message}</div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<SequenceSearchMessageRowProps>(SequenceSearchMessageRow);
